import loadable from '@loadable/component';
import Loading from '../components/Loader';
import { fetchSite, fetchSiteHasValidAbn } from '../actions/sites';
import { fetchRecommendations } from '../actions/recommendations';

const Connect = loadable(() => import(/* webpackChunkName: "connect" */ '../pages/Connect'), {
  fallback: Loading
});

Connect.needs = (props, { dispatch }) => {
  return Promise.all([
    dispatch(fetchSite(props.params.site)),
    dispatch(fetchRecommendations(props.params.site)),
    dispatch(fetchSiteHasValidAbn(props.params.site))
  ]);
};

export default Connect;
